import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const plannedLot = z.object({
  lineItemExternalId: z.string().nullable(),
  productId: z.string(),
  inventoryItemId: z.string(),
  lotNumber: z.string(),
  expirationDate: z.date().nullable(),
  quantity: z.number(),
});

const lotOption = z.object({
  productId: z.string(),
  inventoryItemId: z.string(),
  lotNumber: z.string(),
  expirationDate: z.date().nullable(),
});

export const getPlannedPickSessionLots = {
  name: "getPlannedPickSessionLots" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    fulfillmentGroupId: zExt.objectId(),
  }),
  output: z.object({
    lots: z.array(plannedLot).nullable(),
    options: z.array(lotOption),
  }),
};

export const setPickSessionLotOverride = {
  name: "setPickSessionLotOverride" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    fulfillmentGroupId: zExt.objectId(),
    lineItemExternalId: z.string(),
    inventoryItemId: z.string(),
  }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
